import classNames from "classnames";
import { FC, useRef } from "react";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import useToggle from "../../hooks/useToggle";
import useI18n from "../../hooks/useTranslations";
import SvgInfo from "../icons/Info";
import SvgLink from "../icons/Link";
import Button from "../ui/Button";
import Icon from "../ui/Icon";
import styles from "./ProjectMenuButton.module.css";

interface ProjectMenuButtonProps {
  onDetails: () => void;
  onUnlink?: () => void;
}

const ProjectMenuButton: FC<ProjectMenuButtonProps> = ({ onDetails, onUnlink }: ProjectMenuButtonProps) => {
  const i18n = useI18n();
  const menu = useToggle();
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, menu.close);

  return (
    <div ref={ref} className={styles.wrapper}>
      <Button buttonProps={{ onClick: menu.toggle }}>{i18n.translation.projects.infos}</Button>
      {menu.isOpen && (
        <div className={styles.menu}>
          <ul className={styles.list}>
            <li
              onClick={() => {
                menu.close();
                onDetails();
              }}
            >
              <Icon glyph={SvgInfo} className={styles.icon} />
              {i18n.translation.common.details}
            </li>
            <div className={styles.divider} />
            <li
              className={classNames({ [styles.disabled]: !onUnlink, [styles.red]: !!onUnlink })}
              onClick={() => {
                if (!onUnlink) {
                  return;
                }
                menu.close();
                onUnlink();
              }}
            >
              <Icon glyph={SvgLink} className={styles.icon} />
              {i18n.translation.configurations.unlinkFromProject}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProjectMenuButton;
